import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input,
  Table,
  UncontrolledTooltip,
  ButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap";
import { map } from "lodash";
import { useParams } from "react-router-dom";
import defaultImage from "../../assets/images/default-profile.png";
import AlertSuccess from "../../components/Alerts/AlertSuccess";
import PaginationV2 from "../../components/Pagination/PaginationV2";
import { getCostCenterEmployees, putCostCenterUpdatePolicyEmployee, putEmployeesAdminUpdate } from "../../helpers/api_rombo_helper";
import BreadcrumbLink from "/src/components/Common/BreadcrumbLink";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import EditPolicyCostCenterEmployeeModal from "./EditPolicyCostCenterEmployeeModal";
import AddedEmployeesModal from "./AddedEmployeesModal";
import DeleteEmployeesModal from "./DeleteEmployeesModal";
import DeleteEmployeeModal from "./DeleteEmployeeModal";
import DownloadReportModal from "./DownloadReportModal";
import i18n from "../../i18n";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "../../components/Common/Spinner";
import AlertError from "../../components/Alerts/AlertError";
import { orgId } from "../../constants/utils";
import { Permissions, EmployeeStatus } from "../../constants/enums";

const CostCenter = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);
 
  const [editPolicyCostCenterEmployeeModal, setEditPolicyCostCenterEmployeeModal] = useState(false);
  const toggleViewModalEditPolicyCostCenterEmployee = () => setEditPolicyCostCenterEmployeeModal(!editPolicyCostCenterEmployeeModal);

  const [show, setShow] = useState(false);
  const [selectCostCenter, setSelectCostCenter] = useState({ id: id });

  const [isLoading, setLoading] = useState(true);

  const [drp_link, setDrp_link] = useState(false);
  const [reloadCostCenterEmployees, setReloadCostCenterEmployees] = useState(false);

  const [deleteEmployeesModal, setDeleteEmployeesModal] = useState(false);
  const toggleViewModalEmployeesDelete = () => setDeleteEmployeesModal(!deleteEmployeesModal);

  const [deleteEmployeeModal, setDeleteEmployeeModal] = useState(false);
  const toggleViewModalEmployeeDelete = () => setDeleteEmployeeModal(!deleteEmployeeModal);

  const [addedEmployeesModal, setAddedEmployeesModal] = useState(false);
  const toggleViewModalEmployeesAdded = () => setAddedEmployeesModal(!addedEmployeesModal);

  const [downloadReportModal, setDownloadReportModal] = useState(false);
  const toggleViewModalDownloadReport = () => setDownloadReportModal(!downloadReportModal);

  const [costCenterEmployees, setCostCenterEmployees] = useState({});
  const [findCostCenterEmployees, setFindCostCenterEmployees] = useState([]);
  const [selectEmployee, setSelectEmployee] = useState({});
  const [opts, setOpts] = useState({});

  const [showAlertSuccess, setShowAlertSuccess] = useState(false)
  const [textHeader, setTextHeader] = useState('')
  const [textBody, setTextBody] = useState('')
  const [infoUser, setInfoUser] = useState({ permissions: [] })

  useEffect(() => {
    document.title = `${i18n.t("CostCenter")} - ${orgId}`;
  }, [orgId]);

  useEffect(() => {
    getEmployees()
    getCostCenter()
  }, [reloadCostCenterEmployees, loading]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);

  const getEmployees = (opts = {page: 1, size: 10}) => {
    getCostCenterEmployees(token, id, opts)
      .then((response) => {
        setOpts(opts)
        setCostCenterEmployees(response);
        var result = [];
        response.items.map((item, key) => {
          item.idDB = item.id
          item.id = key
          result.push(item)
        });
        setFindCostCenterEmployees([...result]);
        setLoading(false)
      })
      .catch((error) => {
        console.error("Error - getCostCenterEmployees - ", error)
      })
  }

  const getCostCenter = () => {
    let localSelectCostCenter = localStorage.getItem('SelectCostCenter');
    setSelectCostCenter(JSON.parse(localSelectCostCenter));
  }

  const onChangePagePaginate = (page) => {
    var newOpts = {
      name: autoformik.values.name,
      email: autoformik.values.email,
      size: 10,
      page: page
    }
    getEmployees(newOpts);
  }
  
  const onChangeTotalTrips = (employee, val) => {
    let onFindCostCenterEmployees = findCostCenterEmployees;
    let findEmployee = findCostCenterEmployees.filter((item) => item.id == employee.id).shift()
    if(findEmployee){
      onFindCostCenterEmployees.splice(onFindCostCenterEmployees.indexOf(findEmployee), 1)
      findEmployee.valService = val
      onFindCostCenterEmployees.push(findEmployee)
    }
    onFindCostCenterEmployees.sort((a, b) => (a.id > b.id) ? 1 : -1)
    setFindCostCenterEmployees(onFindCostCenterEmployees)
  }
  
  const onFocusTotalTrips = (employee, val) => {
    let onFindCostCenterEmployees = findCostCenterEmployees;
    let findEmployee = findCostCenterEmployees.filter((item) => item.id == employee.id).shift()
    if(findEmployee){
      onFindCostCenterEmployees.splice(onFindCostCenterEmployees.indexOf(findEmployee), 1)
      findEmployee.editService = true
      onFindCostCenterEmployees.push(findEmployee)
    }
    onFindCostCenterEmployees.sort((a, b) => (a.id > b.id) ? 1 : -1)
    setFindCostCenterEmployees(onFindCostCenterEmployees)
  }

  const autoformik = useFormik({
    initialValues: {
      name: "",
      email: "",
      services: ""
    },
    validationSchema: Yup.object({
      name: Yup.string(),
      email: Yup.string(),
      services: Yup.number()
    })
  });

  const searchFilters = (val, type) => {
    var newOpts = {
      name: type == "name" ? val : autoformik.values.name,
      email: type == "email" ? val : autoformik.values.email,
      size: 10,
      page: 1
    }
    getEmployees(newOpts);
  }

  const onClickTotalTrips = (newEmployeeId, total_trips) => {
    if(total_trips){
      putCostCenterUpdatePolicyEmployee(token, id, newEmployeeId, { total_trips })
        .then((response) => {
          if(response.total_trips){
            setShowAlertSuccess(true)
            setTextHeader(i18n.t("UpdatePolicyEmployee"))
            setTextBody(i18n.t("SuccessUpdatePolicyEmployee"))
            getEmployees(opts);
          }
        })
        .catch((error) => {
          console.error("Error - putCostCenterUpdatePolicyEmployee ", error);
          setErrorAlert(true)
          setErrorAlertMessage((error.response?.data?.detail.toString() || error.message.toString()))
          if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
        })
    }
  }

  const handleSelectCostCenter = (selectCostCenter) => {
    const partnerId = selectCostCenter.partner_id;
    localStorage.setItem('selectedPartnerId', partnerId);
    localStorage.setItem('selectedCostCenterId', selectCostCenter.id);
    localStorage.setItem('selectedCostCenterName', selectCostCenter.name);
  };

  const toggleEmployeeStatus = (employee) => {
    const updatedStatus = employee.status === EmployeeStatus.ACTIVE 
      ? EmployeeStatus.INACTIVE 
      : EmployeeStatus.ACTIVE;
  
    putEmployeesAdminUpdate(token, employee.idDB, { status: updatedStatus })
      .then(() => {
        setShowAlertSuccess(true);
        setTextHeader(i18n.t("EmployeeStatusUpdated"));
        setTextBody(i18n.t("SuccessEmployeeStatusUpdated"));
        getEmployees(opts);
      })
      .catch((error) => {
        console.error("Error - toggleEmployeeStatus: ", error);
        setErrorAlert(true);
        setErrorAlertMessage(error.response?.data?.detail || i18n.t("ErrorUpdatingEmployeeStatus"));
      });
  };
  
  return (
    <Fragment>
      <div className="page-content">
        <BreadcrumbLink title={i18n.t("CostCenter")} link={"/cost-centers"} breadcrumbItem={i18n.t("CostCenter")} />
        <Card>
          <CardBody className="pb-2">
            <Row className="pb-2">
              <Col xs={12} xl={12} md={12} className="pb-2">
                <Row>
                  <Col xxl={9} md={6} xs={12}>
                    <CardTitle className="h4">{selectCostCenter.name}</CardTitle>
                  </Col>
                  <Col xxl={12} md={12} xs={12} className="text-end">
                    <Row className="justify-content-end align-items-center g-2">
                      <Col xxl={2} md={2} xs={3}>
                        <Link to={"/cost-centers"} className="btn btn-go-back">{i18n.t("GoBack")}</Link>
                      </Col>
                      <Col className="col-auto">
                        {infoUser.permissions.includes(Permissions.WRITE_EMPLOYEE) && (
                          <Link to={'/cost-centers/edit/' + id} className="btn btn-request fs-11">
                            {i18n.t("AdminCostCenter")}
                          </Link>
                        )}
                      </Col>
                      <Col className="col-auto">
                        <ButtonDropdown isOpen={drp_link} toggle={() => { setDrp_link(!drp_link) }}>
                          <DropdownToggle className="btn btn-success button-margin-top px-3" caret color="secondary">
                          ⋮
                          </DropdownToggle>
                            <DropdownMenu className="custom-dropdown-menu">
                              <AddedEmployeesModal
                                token={token}
                                setReloadCostCenterEmployees={setReloadCostCenterEmployees}
                                costCenterEmployees={costCenterEmployees}
                                reloadCostCenterEmployees={reloadCostCenterEmployees}
                                selectCostCenter={selectCostCenter}
                                setAddedEmployeesModal={setAddedEmployeesModal}
                                isOpen={addedEmployeesModal}
                                toggle={toggleViewModalEmployeesAdded}
                                setShowAlertSuccess={setShowAlertSuccess}
                                setTextHeader={setTextHeader}
                                setTextBody={setTextBody}
                              />
                              {infoUser.permissions.includes(Permissions.WRITE_EMPLOYEE) && (
                                <DropdownItem onClick={toggleViewModalEmployeesAdded}>
                                  {i18n.t("AddEmployees")}
                                </DropdownItem>
                              )}
                              <DeleteEmployeesModal
                                token={token}
                                setReloadCostCenterEmployees={setReloadCostCenterEmployees}
                                reloadCostCenterEmployees={reloadCostCenterEmployees}
                                setDeleteEmployeesModal={setDeleteEmployeesModal}
                                isOpen={deleteEmployeesModal}
                                toggle={toggleViewModalEmployeesDelete}
                                setShowAlertSuccess={setShowAlertSuccess}
                                setTextHeader={setTextHeader}
                                selectCostCenter={selectCostCenter}
                                setTextBody={setTextBody}
                              />
                              {infoUser.permissions.includes(Permissions.COST_CENTER_EMPLOYEES_DELETE) && (
                                <DropdownItem onClick={toggleViewModalEmployeesDelete}>
                                  {i18n.t("DeleteEmployees")}
                                </DropdownItem>
                              )}
                              <DownloadReportModal
                                token={token}
                                setDownloadReportModal={setDownloadReportModal}
                                isOpen={downloadReportModal}
                                selectCostCenter={selectCostCenter}
                                toggle={toggleViewModalDownloadReport}
                                setShowAlertSuccess={setShowAlertSuccess}
                                setTextHeader={setTextHeader}
                                setTextBody={setTextBody}
                              />
                              <DropdownItem onClick={toggleViewModalDownloadReport}>
                                {i18n.t("DownloadReportCostCenter")}
                              </DropdownItem>
                              <DropdownItem onClick={() => handleSelectCostCenter(selectCostCenter)}>
                                <Link to={`/cost-centers/sub-admin/${id}`} className="dropdown-link">
                                  {i18n.t("AssignSubAdmins")}
                                 </Link>
                              </DropdownItem>
                              <DropdownItem onClick={() => handleSelectCostCenter(selectCostCenter)}>
                                <Link to={`/cost-centers/sub-admins/${id}`} className="dropdown-link">
                                  {i18n.t("ViewSubAdmins")}
                                </Link>
                              </DropdownItem>
                            </DropdownMenu>
                        </ButtonDropdown>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} xl={12} md={6} className="pb-2">
              <div className="orange-separator" />
                <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
                  <Col xxl={4} md={4} xs={12}>
                    <div className="col-sm-auto">                        
                      <Input
                        type="text"
                        name="name"
                        className="form-control"
                        id="nameInput"
                        placeholder={i18n.t("SearchName")}
                        value={autoformik.values.name}
                        onBlur={autoformik.handleBlur}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "name")
                        }}
                        invalid={
                          autoformik.touched.name && autoformik.errors.name ? true : false
                        }
                      />
                      {autoformik.errors.name && autoformik.touched.name && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.name}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                  <Col xxl={2} md={2} xs={12}>
                    <div className="col-sm-auto">
                      <Input
                        type="text"
                        name="email"
                        className="form-control"
                        id="emailInput"
                        placeholder={i18n.t("Email")}
                        value={autoformik.values.email}
                        onBlur={autoformik.handleBlur}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "email")
                        }}
                        invalid={
                          autoformik.touched.email && autoformik.errors.email ? true : false
                        }
                      />
                      {autoformik.errors.email && autoformik.touched.email && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.email}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                </Form>
                <div className="orange-separator margin-separator" />
                <div className="table-responsive pt-3">
                  <Table className="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline">
                    <thead>
                      <tr>
                        <th className="table-header2">#</th>
                        <th className="table-header2">{i18n.t("Name")}</th>
                        <th className="table-header2">{i18n.t("Email")}</th>
                        {infoUser.is_staff && (
                          <th className="table-header2">{i18n.t("Partner")}</th>
                        )}
                        <th className="table-header2">{i18n.t("ServicesAvailable")}</th>
                        <th className="table-header2">{i18n.t("Status")}</th>
                        <th className="table-header2">{i18n.t("Actions")}</th>
                      </tr>
                    </thead>
                    {
                      isLoading ? null :
                        <tbody>
                          {map(findCostCenterEmployees, (employee, key) => (
                            <tr key={employee.id}>
                              <td><img src={defaultImage} className="avatar-xs rounded-circle" alt=""></img></td>
                              <td>{employee.name}</td>
                              <td>{employee.email}</td>
                              {infoUser.is_staff && <td>{employee.partner_name}</td>}
                              <td className="text-center align-middle">
                                {employee.available_trips === -1 ? (
                                  <span className="d-block">{i18n.t("NotApplicable")}</span>
                                ) : (
                                  <div className="d-flex">
                                    <Col xxl={4} md={4} xs={12} className="mx-2">
                                      <Input
                                        type="number"
                                        name="total_trips"
                                        min="0"
                                        onFocus={(e) => onFocusTotalTrips(employee)}
                                        onChange={(e) => {
                                          const value = Math.max(0, Number(e.target.value));
                                          onChangeTotalTrips(employee, value);
                                        }}
                                        className=""
                                        placeholder={employee.available_trips}
                                      />
                                    </Col>
                                    <Col xxl={4} md={4} xs={12} className="text-start">
                                      {employee.editService && (
                                        <button
                                          onClick={(e) => {
                                            onClickTotalTrips(employee.idDB, employee.valService)
                                            e.target.value = null
                                          }} 
                                          className="btn btn-users fs-8">
                                            {i18n.t("Save")}
                                        </button>
                                      )}
                                    </Col>
                                  </div>
                                )}
                              </td>
                              <td className="align-middle">
                                <div className={`bg-${employee.status.toLowerCase()} text-white rounded-2 text-center p-1 fs-10`}>
                                  {i18n.t(employee.status)}
                                </div>
                              </td>
                              <td>
                                <div className="d-flex gap-3">
                                  <Link
                                    className="text-success"
                                    to={`/employees/edit/${employee.idDB}`}
                                  >
                                    <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                    <UncontrolledTooltip placement="top" target="edittooltip">
                                      {i18n.t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  <Link
                                    className="text-danger"
                                    onClick={() => {
                                      setSelectEmployee(employee);
                                      setDeleteEmployeeModal(true);
                                    }}>
                                    <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                    <UncontrolledTooltip placement="top" target="deletetooltip">
                                      {i18n.t("Eliminated")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  <Link
                                    className="text-active"
                                    to="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleEmployeeStatus(employee);
                                    }}
                                  >
                                    <i className={`mdi ${employee.status === EmployeeStatus.ACTIVE ? "mdi-lock" : "mdi-lock-open"} font-size-18`} id={`status-tooltip-${employee.idDB}`} />
                                    <UncontrolledTooltip placement="top" target={`status-tooltip-${employee.idDB}`}>
                                      {employee.status === EmployeeStatus.ACTIVE ? i18n.t("Inactived") : i18n.t("Actived")}
                                    </UncontrolledTooltip>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                    }
                  </Table>
                  {isLoading ? (
                    <Spinners setLoading={setLoading} />
                  ) : (
                  <PaginationV2
                    currentPage={costCenterEmployees.page}
                    pageSize={costCenterEmployees.size}
                    totalItems={costCenterEmployees.total}
                    onChangePage={onChangePagePaginate}
                  />
                  )}
                  <DeleteEmployeeModal
                    token={token}
                    selectCostCenter={selectCostCenter}
                    selectEmployee={selectEmployee}
                    setReloadCostCenterEmployees={setReloadCostCenterEmployees}
                    reloadCostCenterEmployees={reloadCostCenterEmployees}
                    setDeleteEmployeeModal={setDeleteEmployeeModal}
                    isOpen={deleteEmployeeModal}
                    toggle={toggleViewModalEmployeeDelete}
                    setShowAlertSuccess={setShowAlertSuccess}
                    setTextHeader={setTextHeader}
                    setTextBody={setTextBody}
                  />
                  <EditPolicyCostCenterEmployeeModal
                    token={token}
                    selectCostCenter={selectCostCenter}
                    selectEmployee={selectEmployee}
                    setReloadCostCenterEmployees={setReloadCostCenterEmployees}
                    reloadCostCenterEmployees={reloadCostCenterEmployees}
                    setEditPolicyCostCenterEmployeeModal={setEditPolicyCostCenterEmployeeModal}
                    isOpen={editPolicyCostCenterEmployeeModal}
                    toggle={toggleViewModalEditPolicyCostCenterEmployee}
                    setShowAlertSuccess={setShowAlertSuccess}
                    setTextHeader={setTextHeader}
                    setTextBody={setTextBody}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <AlertSuccess
          showAlertSuccess={showAlertSuccess}
          setShowAlertSuccess={setShowAlertSuccess}
          textHeader={textHeader}
          textBody={textBody}
        />
        <AlertError
          showAlertError={errorAlert}
          setShowAlertError={setErrorAlert}
          textHeader={i18n.t("Error")}
          textBody={errorAlertMessage}
        />
      </div>
    </Fragment>
  )
}

CostCenter.propTypes = {
  onGetCostCenter: PropTypes.func,
  getCostCenter: PropTypes.func
}

export default CostCenter;
